<template>
  <div>
    <label for="pi2">HASH (TXID)</label>
    <div class="input-group has-clearable">
      <button
        type="button"
        class="close show text-success"
        aria-label="Close"
        v-clipboard:copy="invoice.txid"
        v-clipboard:success="onCopy"
      >
        <span aria-hidden="true">
          <i class="far fa-clone"></i>
        </span>
      </button>

      <label class="input-group-prepend" for="pi2">
        <span class="input-group-text">
          <i class="far fa-paper-plane"></i>
        </span>
      </label>
      <input type="text" class="form-control" id="pi2" :value="invoice.txid" />
    </div>
    <small>
      <a
        class="text-warning"
        target="_blank"
        :href="`https://www.blockchain.com/btc/tx/${invoice.txid}`"
      >
        <i class="fa fa-link"></i>
        VIEW ON BLOCKCHAIN
      </a>
    </small>
  </div>
</template>

<script>
export default {
  name: "invoice-paid",
  props: {
    invoice: {
      type: Object,
      default: {}
    }
  },
  methods: {
    onCopy() {
      this.$toasted.show("Copied to clippboard!", {
        position: "top-right",
        duration: 5000,
        type: "success",
        closeOnSwipe: true
      });
    }
  }
};
</script>
